import { FC } from "react";
import { useAuth } from "@/data/context/authContext";
import { Navigate } from "react-router-dom";
import ROUTES from "@/data/Routes";
import Loading from "@/components/Loading";
import { GoalsPanel } from "@/components/Dashboard/GoalsPanel";
import { ResultsPanel } from "@/components/Dashboard/ResultsPanel";
import { ActionPlanCards } from "@/components/Dashboard/ActionPlanCards";
import { ROLES } from "@/data/interfaces/RolesEnum";

const Dashboard: FC = () => {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loading className="mt-20" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  return (
    <div className="flex gap-6 p-8">
      <div className="flex-1">
        {user.role === ROLES.USER && <ActionPlanCards />}
      </div>
      {user.role === ROLES.USER && (
        <div className="hidden h-full flex-col gap-6 md:flex">
          <ResultsPanel />
          <GoalsPanel />
        </div>
      )}
    </div>
  );
};

export default Dashboard;
